import { Tooltip } from '@mui/material';

import type { TableColumnConfig } from '@/types/common/table-config.type';
import { RoleEnum } from '@/types/enums/role.enum';
import { dateUtils } from '@/utils/date';

export const columns = (): TableColumnConfig[] => [
    {
        field: 'name',
        headerName: 'Tên lịch',
        flex: 1,
        renderCell: (params: any) => params.row?.name || '-:-',
    },
    {
        field: 'scheduledTime',
        headerName: 'Ngày bảo trì thực tế',
        flex: 1,
        renderCell: (params: any) =>
            dateUtils.getDate(params.row?.scheduledTime),
    },
    {
        field: 'nextMaintenanceDate',
        headerName: 'Dự kiến bảo trì kế tiếp',
        flex: 1,
        renderCell: (params: any) =>
            dateUtils.getDate(params.row?.nextMaintenanceDate),
    },
    {
        field: 'assignessName',
        headerName: 'Kỹ thuật viên',
        flex: 1,
        renderCell: params => (
            <Tooltip title={params.row?.assignessName}>
                {params.row?.assignessName || '-:-'}
            </Tooltip>
        ),
        excludeRoles: [RoleEnum.KTV],
    },
    {
        field: 'taskCheckCode',
        headerName: 'Mã Task',
        flex: 1,
        renderCell: params => (
            <Tooltip title={params.row?.taskCheckCode}>
                {params.row?.taskCheckCode || '-:-'}
            </Tooltip>
        ),
    },
];
